import { useExperimentEnrollment } from '@confluence/experiment-reverse-trial-message-suppression/entry-points/hooks/useExperimentEnrollment';

interface UseEnrolledInRtPaidFeatureEducationExperimentProps {
	skip?: boolean;
	extraAnalyticsAttributes?: object;
}

export const useEnrolledInRtPaidFeatureEducationAAExperiment = ({
	skip = false,
	extraAnalyticsAttributes = {},
}: UseEnrolledInRtPaidFeatureEducationExperimentProps) => {
	const { isTreatment, loading, error } = useExperimentEnrollment({
		experimentId: 'rt_paid_feature_education_aa',
		featureGateId: 'rt_paid_feature_education_aa_fg',
		skip,
		extraAnalyticsAttributes,
	});

	return {
		isTreatment,
		loading,
		error,
	};
};

export const useEnrolledInRtPaidFeatureEducationABExperiment = ({
	skip = false,
	extraAnalyticsAttributes = {},
}: UseEnrolledInRtPaidFeatureEducationExperimentProps) => {
	const { isTreatment, loading, error, daysLeftInTrial, isInTrialOrPreDunning } =
		useExperimentEnrollment({
			experimentId: 'rt_paid_feature_education_ab',
			featureGateId: 'rt_paid_feature_education_ab_fg',
			skip,
			extraAnalyticsAttributes,
		});

	return {
		isTreatment,
		loading,
		error,
		daysLeftInTrial,
		isInTrialOrPreDunning,
	};
};
